/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureASquareDownIcon16Light } from './ArrowFigureASquareDownIcon16Light';
import { ArrowFigureASquareDownIcon16Regular } from './ArrowFigureASquareDownIcon16Regular';
import { ArrowFigureASquareDownIcon16Solid } from './ArrowFigureASquareDownIcon16Solid';
import { ArrowFigureASquareDownIcon20Light } from './ArrowFigureASquareDownIcon20Light';
import { ArrowFigureASquareDownIcon20Regular } from './ArrowFigureASquareDownIcon20Regular';
import { ArrowFigureASquareDownIcon20Solid } from './ArrowFigureASquareDownIcon20Solid';
import { ArrowFigureASquareDownIcon24Regular } from './ArrowFigureASquareDownIcon24Regular';
import { ArrowFigureASquareDownIcon24Solid } from './ArrowFigureASquareDownIcon24Solid';
import { ArrowFigureASquareDownIcon32Regular } from './ArrowFigureASquareDownIcon32Regular';
import { ArrowFigureASquareDownIcon64Regular } from './ArrowFigureASquareDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureASquareDownIcon16Light,
        regular: ArrowFigureASquareDownIcon16Regular,
        solid: ArrowFigureASquareDownIcon16Solid,
    },
    20: {
        light: ArrowFigureASquareDownIcon20Light,
        regular: ArrowFigureASquareDownIcon20Regular,
        solid: ArrowFigureASquareDownIcon20Solid,
    },
    24: {
        regular: ArrowFigureASquareDownIcon24Regular,
        solid: ArrowFigureASquareDownIcon24Solid,
    },
    32: {
        regular: ArrowFigureASquareDownIcon32Regular,
    },
    64: {
        regular: ArrowFigureASquareDownIcon64Regular,
    },
};
export var ArrowFigureASquareDownIcon = forwardRef('ArrowFigureASquareDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
